<template>
  <div class="attributeApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    
    <dl v-for="(vo,i) in attr">
      <dt>
        <input type="text" v-model="vo.name" placeholder="属性标题定义">
        <a @click="add(i)"><em class="el-icon-plus"></em>添加</a>
        <a @click="del(i)" style="background:#E34D59"><em class="el-icon-plus"></em>删除</a>
      </dt>
      <dd>
        <div v-for="(v,k) in vo.child">
          <input type="text" v-model="v.name" placeholder="分类">
          <font>-</font>
          <input class="price" type="text" v-model="v.price" placeholder="价格">
          <em class="el-icon-error" @click="remove(i,k)"></em>
        </div>
      </dd>
      <div class="addAttr" @click="oneAdd" v-if="attr.length == i+1"><i class="el-icon-circle-plus-outline"></i> 新增属性</div>
    </dl>
    <div style="height:78px"></div>
    <div class="btn" @click="save">保存</div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        attr:[{'name':'','child':[{'name':'',price:0}]}]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getAttribute();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      oneAdd:function(){
        var attr = this.attr;
        attr.push({name:'',child:[{name:'',price:0}]})
      },
      add:function(inx){
        var attr = this.attr[inx].child;
        attr.push({name:'',price:0})
      },
      del:function(inx){
        var attr = this.attr;
        attr.splice(inx,1);
      },
      remove:function(inx,k){
        var attr = this.attr[inx].child;
        attr.splice(k,1);
      },
      getAttribute:function(){
        var that = this;
        var mall_id = this.$route.query.id;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/getAttribute',
          data:{
            id:mall_id,
          },
          dataType:'json',
          success:function(data){
            if(data.data != null){
              that.attr = data.data.content
            }
            that.fullscreenLoading = false;
          }
        })
      },
      save:function(){
        var that = this;
        var attr = that.attr;
        for(var i=0;i<attr.length;i++){
          if(attr[i].name == ''){
            that.$alert('检查是否有选项没有填写!', '提示')
            return false;
          }
          for(var k=0;k<attr[i].child.length;k++){
            if(attr[i].child[k].name == ''){
              that.$alert('检查是否有选项没有填写!', '提示')
              return false;
            }
          }
        }
        var mall_id = this.$route.query.id;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/saveAttribute',
          data:{
            id:mall_id,
            content:JSON.stringify(attr)
          },
          dataType:'json',
          success:function(data){
            that.$alert('保存成功!', '提示');
            that.fullscreenLoading = false;
          }
        })
        return false;
      },
    }
  };
</script>
<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .attributeApp{
    max-width:640px;
    background:#ebebeb;
    margin:0 auto;
  }

  input::-webkit-input-placeholder,textarea::-webkit-input-placeholder { color: #BCC4D0 !important; } 
  input::-moz-input-placeholder,textarea::-webkit-input-placeholder { color: #BCC4D0 !important;} 
  input::-ms-input-placeholder,textarea::-webkit-input-placeholder { color: #BCC4D0 !important;}

  .attributeApp dl{
    background:#fff;
    margin-bottom:12px
  }
  .attributeApp dl dt{
    height:50px;
    border-bottom:solid 1px #EBEDF1
  }

  .attributeApp dl dt input{
    float:left;
    width:120px;
    height:35px;
    border:none;
    background: #F1F2F5;
    outline:none;
    margin:8px 0 0 8px;
    border-radius: 5px;
    text-align:center;
    font-size:15px;
    color:#000
  }
  .attributeApp dl dt a{
    float:right;
    background: #0059D6;
    height: 30px;
    width: 64px;
    text-align:center;
    line-height: 30px;
    border-radius: 30px;
    color: #FFFFFF;
    font-size: 15px;
    margin:10px 10px 0 0;
  }
  .attributeApp dl dd {
    padding:15px 8px;
    display: grid;
    grid-template-columns: repeat(3, 31%);
    gap: 10px;
  }
  .attributeApp dl dd div{
    position:relative;
    height:35px;

  }
  .attributeApp dl dd div em{
    top:-5px;
    left:-5px;
    position:absolute;
    color:#E34D59
  }
  .attributeApp dl dd input{
    height:35px;
    width:65%;
    border:none;
    background: #F1F2F5;
    outline:none;
    text-align:center;
    border-radius: 5px;
    float:left;
    font-size:12px
  }
  .attributeApp dl dd input.price{
    width:30%
  }
  .attributeApp dl dd font{
    float:left;
    line-height:35px;
    color:#666
  }
  .attributeApp .btn{
    background: #0053C7;
    height: 44px;
    width: 164px;
    border-radius: 5px;
    margin:0 auto;
    color: #FFFFFF;
    text-align:center;
    line-height: 44px;
    font-size:15px;
    position:fixed;
    bottom:22px;
    left:50%;
    transform: translateX(-50%);
  }
  .attributeApp dl .addAttr{
    text-align:center;
    height: 44px;
    margin:0 auto;
    border-top: 6px solid #EBEDF1;
    line-height: 44px;
    color: #0059D6;
  }
</style>